import { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Editor, Frame } from '@craftjs/core';
import lz from 'lzutf8';

import useRouterDom from '../../../hooks/useRouterDom';
import { useLazyFindOnePageQuery } from '../../../features/PageBuilder/store/pageBuilderApi';

import LoadingScreen from '../../../components/Loading/LoadingScreen/LoadingScreen';
import RenderNode from '../../../features/PageBuilder/Editor/RenderNode';

import Container from '../../../features/PageBuilder/Elements/Container';
import Text from '../../../features/PageBuilder/Elements/Text';
import RichText from '../../../features/PageBuilder/Elements/RichText';
import Image from '../../../features/PageBuilder/Elements/Image';
import VimeoVideo from '../../../features/PageBuilder/Elements/VimeoVideo';

import '../PageBuilder.scss';
import './PageBuilderViewPage.scss';

function PageBuilderViewPage() {
  const { urlParams } = useRouterDom();
  const navigate = useNavigate();
  const [getOnePage] = useLazyFindOnePageQuery();
  const [pageData, setPageData] = useState<any>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasNoContent, setHasNoContent] = useState<boolean>(false);
  const location = useLocation();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const loadPageContent = async () => {
    setIsLoading(true);
    const { data } = await getOnePage({ slug: urlParams.slug, status: 'Published' });
    setPageData(lz.decompress(lz.decodeBase64(data.page_data)));
  };

  useEffect(() => {
    loadPageContent();
  }, [location]);

  useEffect(() => {
    loadPageContent();
    const flexRowAsideElement = document.querySelector('.flex-row aside');
    flexRowAsideElement?.classList.add('hideSideMenu');
    return () => {
      flexRowAsideElement?.classList.remove('hideSideMenu');
    };
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setIsLoading(false);
          observer.disconnect();
        }
      }
    });

    observer.observe(containerRef.current, {
      childList: true,
      subtree: true,
    });

    if (pageData !== undefined) {
      const json = JSON.parse(pageData);
      if (json.ROOT.nodes.length === 0) {
        setHasNoContent(true);
        setTimeout(() => {
          setIsLoading(false);
          navigate("/");
        }, 2000);
      }
    }

    return () => observer.disconnect();

  }, [pageData]);

  if (!isLoading && !pageData) {
    return <Navigate replace to="/" />;
  }

  return (
    <>
      {isLoading && <LoadingScreen />}
      <div className="tw-w-full" ref={containerRef}>
        {pageData && (
          <Editor resolver={{ Container, Text, RichText, Image, VimeoVideo }} enabled={false} onRender={RenderNode}>
            <div className="tw-relative tw-z-[1040] tw-flex tw-flex-row">
              <div className="tw-flex tw-w-full tw-flex-col">
                <div className="page-editor tw-flex tw-flex-col">
                  <div className="tw-flex tw-flex-row">
                    {hasNoContent ? (
                      <h1 className='text-xl' style={{ 'textAlign': 'center', 'width': '100%' }}>Page has no content.</h1>
                    ) : (<Frame data={pageData} />)}

                    {/* <Element
                        canvas
                        is={Container}
                        width="100%"
                        height="100vh"
                        background={{ r: 255, g: 255, b: 255, a: 1 }}
                        padding={['40', '40', '40', '40']}
                        custom={{ displayName: 'Page' }}
                      /> */}
                    {/* </Frame> */}
                  </div>
                </div>
              </div>
            </div>
          </Editor>
        )}
      </div>
    </>
  );
}

export default PageBuilderViewPage;
